<template>
  <div class="grid-container">
    <div class="item1">
      <img style="vertical-align:middle"
           src="../assets/helpMB.svg" @click="showModal = true">
      <span style="padding-left:5px; color: white" @click="showModal = true">{{ t('footer_help') }}</span>
    </div>
    <div v-if="showModal" class="overlay" @click="showModal = false"></div>
    <div class="help-modal">
      <modal class="modal" v-if="showModal" @close="showModal = false">
          <button class="close" @click="showModal = false">x</button>
          <h3 class="provider-header">The following providers are supported</h3>
          <li class="providers-list" v-for="(item, index) in providers" v-bind:key="index">{{item}}</li>
           <li class="providers-list">
             Business/Private domains which have ICO purchased as B2B service can be connected using "Others"
            </li>
      </modal>
    </div>
  </div>

</template>

<script>
import { useI18n } from "vue-i18n";
import axios from "axios";
export default {
  name: "FooterView",
  setup() {
    const { t, locale } = useI18n();
    return {
      t, locale
    };
  },
  data() {
    return {
      showModal: false,
      providers: [],
      query: null,
      hu : "",
      cod: ""
    }
  },
  beforeMount() {
    let searchParams = new URLSearchParams(window.location.search);
    this.hu= searchParams.get('hu').replaceAll("\\","");
    this.cod = searchParams.get('cod');
    axios
        .get("/api/providerList",{params:{ hu: this.hu , footer: "enabled", cod: this.cod }})
        .then(response => {
          this.providers = response.data
        })
        .catch();
  },
}
</script>

<style scoped>

.grid-container {
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: black;
  padding: 10px;
  bottom: -10px;
  width: 100%;
}

.grid-container>div {
  background-color: rgba(0, 0, 0, 0.7);
  text-align: center;
  padding: 20px 0;
}

.providers-list{
  list-style-type:decimal;
  text-align: left;
  font-size: 0.8rem;
  padding: 0px;
}

.help-modal {
  display: flex;
  justify-content: center;
  padding: 1rem;
}

.modal {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: white;
  padding: 1rem;
  width:40%
}

.overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.7%);
}

.close{
  position: absolute;
  top: 0;
  right: 0;
  font-size: 0.9rem;
  cursor: pointer;
  margin :2.5% 3%;
}

h3{
  font-weight: bold;
}
/*Media query for smaller size phone screens*/
@media (max-width: 480px){
  h3{
    font-size:14px;
    margin:5%;
  }
  .providers-list{
    margin:-12% 3%;
    padding: 13px;
  }
  .modal{
    width: 50%;
  }

}

/* Extra small devices (phones, 600px and down) */
@media only screen and (max-width: 600px) {

}
/* Small devices (portrait tablets and large phones, 600px and up) */
@media only screen and (min-width: 600px) {

}
/* Medium devices (landscape tablets, 768px and up) */
@media only screen and (min-width: 768px) {


}
/* Large devices (laptops/desktops, 992px and up) */
@media only screen and (min-width: 992px) {

}
/* Extra large devices (large laptops and desktops, 1200px and up) */
@media only screen and (min-width: 1200px) {

}
</style>